var map = {
	"./honeywell/brands/honeywell/bandevideo.jpg": "7021",
	"./linkwil/brands/linkwil/bandevideo.jpg": "0c1b",
	"./smart_home/brands/welcome_home/bandevideo.jpg": "084b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4f06";